module.exports = __webpack_public_path__ + "static/media/brian-anthony-wilson.5c991b39.md";